import { Link } from 'react-router-dom';
import { trustIndicators, articlePreview } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20retail%20display%20of%20carefully%20curated%20fashion%20items%20including%20premium%20sneakers%2C%20a%20folded%20cashmere%20sweater%20in%20warm%20beige%2C%20a%20leather%20handbag%2C%20and%20minimalist%20accessories%20arranged%20on%20a%20light%20oak%20table%2C%20soft%20golden%20hour%20sunlight%20streaming%20through%20large%20windows%2C%20warm%20cream%20walls%2C%20sophisticated%20boutique%20atmosphere%2C%20editorial%20lifestyle%20photography%20with%20rich%20textures%2C%20natural%20shadows%2C%20and%20harmonious%20earth%20tone%20color%20palette&width=1920&height=1080&seq=hero-v2-basetao&orientation=landscape"
          alt="Basetao Spreadsheet - Premium product curation platform"
          title="Basetao Spreadsheet - Discover Better Products"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-20 pb-12">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-8">
            <div className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></div>
            <span className="text-xs font-medium text-background-50/90 tracking-wide">Updated for August 2026</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
            Basetao Spreadsheet
            <span className="block text-background-50/80 font-normal text-xl md:text-2xl lg:text-3xl mt-3">
              The Smartest Way To Discover Better Products
            </span>
          </h1>

          <p className="text-base md:text-lg text-background-50/80 mb-10 max-w-2xl mx-auto leading-relaxed">
            Explore updated Basetao Spreadsheet resources, product guides, reviews, shipping information, 
            warehouse explanations, and exclusive shopping strategies — all in one organized platform.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-xl text-base font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-external-link-line mr-2"></i>
              basetao spreadsheet
            </a>
            <Link
              to={articlePreview.slug}
              className="w-full sm:w-auto px-8 py-3.5 rounded-xl text-base font-semibold bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 hover:bg-background-50/25 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-book-open-line mr-2"></i>
              Read Our Guide
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-xl text-base font-semibold bg-accent-500 text-background-50 hover:bg-accent-600 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-shopping-cart-line mr-2"></i>
              Buy It Now
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6">
            {trustIndicators.map((item) => (
              <div key={item.text} className="flex items-center gap-1.5 text-xs text-background-50/70">
                <i className={`${item.icon} text-accent-400`}></i>
                <span className="whitespace-nowrap">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-2xl text-background-50/60"></i>
      </div>
    </section>
  );
}